<div [ngClass]="containerClass()">
  <svg
    viewBox="0 0 200 200"
    class="block h-full w-full"
    role="img"
    [attr.aria-label]="value() + ' out of ' + maxValue()">
    <title>{{ value() }} out of {{ maxValue() }}</title>
    <defs>
      <linearGradient [attr.id]="gradientId" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stop-color="#E6F1D4" />
        <stop offset="100%" [attr.stop-color]="scoreStroke()" />
      </linearGradient>
    </defs>
    <path
      d="M 20 120 A 80 80 0 0 1 180 120"
      fill="none"
      [attr.stroke]="backgroundStroke()"
      stroke-width="16"
      stroke-linecap="butt"
      pathLength="100" />
    <path
      d="M 20 120 A 80 80 0 0 1 180 120"
      fill="none"
      [attr.stroke]="'url(#' + gradientId + ')'"
      stroke-width="16"
      stroke-linecap="butt"
      pathLength="100"
      [attr.stroke-dasharray]="dashArray()"
      stroke-dashoffset="0" />
    <text
      x="100"
      y="100"
      text-anchor="middle"
      dominant-baseline="auto"
      fill="#1f2937"
      font-weight="700"
      font-family="inherit"
      [attr.font-size]="valueFontSize()">
      {{ value() }}
    </text>
    <text
      x="100"
      y="115"
      text-anchor="middle"
      dominant-baseline="auto"
      fill="#6b7280"
      font-family="inherit"
      [attr.font-size]="labelFontSize()">
      OUT OF {{ maxValue() }}
    </text>
  </svg>
</div>
